import React from 'react'
import { connect } from 'react-redux'
import MapController from './MapController'

import { startCalendarSync, stopCalendarSync } from 'infra/actions/calendars'

class MapContainer extends React.PureComponent {

  constructor(props) {
    super(props);

    this.state = {}
    this.subscriptions = {}
  }

  componentWillMount() {
    this.initLoaders(this.props.selectedWorkers, this.props.dateStr)
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.dateStr !== nextProps.dateStr){
      this.detachLoaders(this.props.selectedWorkers, this.props.dateStr)
      this.initLoaders(nextProps.selectedWorkers, nextProps.dateStr)
    }

    if (this.props.selectedWorkers !== nextProps.selectedWorkers){
      const {newWorkers, oldWorkers} = this.getWorkerDifference(this.props.selectedWorkers, nextProps.selectedWorkers)
      this.detachLoaders(oldWorkers, this.props.dateStr)
      this.initLoaders(newWorkers, nextProps.dateStr)
    }

  }

  componentWillUnmount() {
    this.detachLoaders(this.props.selectedWorkers, this.props.dateStr)
  }

  initLoaders = (workers, dateStr) => {
    workers.forEach(worker => {
      const userId = worker.userId;
      const calendarId = `${userId}@${worker.teamId}`;
      this.subscribeToCalendars(calendarId, dateStr)
    })
  }

  detachLoaders = (workers, dateStr) => {
    workers.forEach(worker => {
      const userId = worker.userId;
      const calendarId = `${userId}@${worker.teamId}`;
      this.unsubscribeToCalendars(calendarId, dateStr)
    })
  }

  subscribeToCalendars = (calendarId, dateStr) => {
    this.subscriptions[calendarId] = true
    this.props.dispatch(startCalendarSync(calendarId, dateStr))
  }

  unsubscribeToCalendars = (calendarId, dateStr) => {
    if (this.subscriptions[calendarId]){
      delete this.subscriptions[calendarId]
      this.props.dispatch(stopCalendarSync(calendarId, dateStr))
    }
  }

  getWorkerDifference = (thisWorkers, nextWorkers) => {
    const thisWorkerCache = this.dictionarize(thisWorkers, 'dbKey')
    const nextWorkersCache = this.dictionarize(nextWorkers, 'dbKey')
    const oldWorkers = thisWorkers.filter(worker => !nextWorkersCache[worker] )
    const newWorkers = nextWorkers.filter(worker => !thisWorkerCache[worker] )

    return { oldWorkers, newWorkers }
  }

  dictionarize = (array, key) => {
    const cache = {}
    array.forEach(value => cache[value[key]] = value)
    return cache
  }

  render() {
    return (
      <div
        style={{ display: 'flex',
          flexDirection: 'column',
          overflowY: 'auto',
          overflowX: 'hidden',
          width: '100%'
        }}>
        <MapController
          dateStr={this.props.dateStr}
          selectedWorkers={this.props.selectedWorkers}/>
      </div>
    );
  }
}

export default connect(state => ({ instances: state.schedule.instances }))(MapContainer)



// WEBPACK FOOTER //
// ./src/schedule/map/MapContainer.js